import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/tokens.css';
import './theme/tables.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FEATURE_FLAGS } from './config/featureFlagKeys';

(window as any).FEATURE_FLAGS = FEATURE_FLAGS;

// Expose individual keys for direct access
Object.entries(FEATURE_FLAGS).forEach(([key, value]) => {
  (window as any)[key] = value;
});



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
